
import { Component, Vue } from "vue-property-decorator";
import AskGovDetail from "@/template/askGov/AskGovDetail.vue";
@Component
export default class AskGovDetails extends AskGovDetail {}
